import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEditableField, setEditableFieldValue } from '../store';
export var useEditableField = function (name) {
    var field = useSelector(function (state) { return getEditableField(state, name); });
    var dispatch = useDispatch();
    var setValue = useCallback(function (value) {
        dispatch(setEditableFieldValue({ name: name, value: value }));
    }, [dispatch, name]);
    return {
        field: field,
        setValue: setValue,
    };
};
